export default __webpack_public_path__ + "_/assets/img/call-to-action-bg.webp";